import { ArrowLeft } from 'lucide-react'
import { LmsButton } from '@shared/ui'
import {
  LearningLessonShell,
  LearningLessonShellContent,
} from '../LearningLessonShell'
import { LearningExerciseToolbar } from '../learning-exercise-toolbar'
import type {
  LearningTemplateGameResultProps,
  LearningTemplateGameShellProps,
} from './learning-template-contract'
import './learning-template-game-shell.css'

function joinClassNames(...classNames: Array<string | undefined>) {
  return classNames.filter(Boolean).join(' ')
}

export function LearningTemplateGameShell({
  children,
  className,
  closeLabel,
  contentClassName,
  headerClassName,
  onClose,
  progress,
  progressLabel,
  rightSlot,
  title,
}: LearningTemplateGameShellProps) {
  return (
    <LearningLessonShell className={joinClassNames('learningTemplateGameShell', className)}>
      <LearningExerciseToolbar
        backSlot={
          <>
            <h2 className="learningTemplateGameHeaderTitle">{title}</h2>
            <LmsButton
              aria-label={closeLabel}
              className="rounded-full"
              leadingIcon={<ArrowLeft aria-hidden="true" className="size-6" />}
              onClick={onClose}
              size="icon-lg"
              type="button"
              variant="ghost"
            >
              <span className="sr-only">{closeLabel}</span>
            </LmsButton>
          </>
        }
        centerSlotClassName="learningTemplateGameHeaderCenter"
        className={joinClassNames('learningTemplateGameHeader', headerClassName)}
        leftSlotClassName="learningTemplateGameHeaderStart"
        progress={progress}
        progressLabel={progressLabel}
        progressTrackClassName="learningTemplateGameProgress"
        progressValueClassName="learningTemplateGameProgressValue"
        rightSlot={rightSlot}
        rightSlotClassName="learningTemplateGameHeaderEnd"
      />
      <LearningLessonShellContent
        className={joinClassNames('learningTemplateGameContent', contentClassName)}
        pageWrapClassName="learningTemplateGamePageWrap"
        viewportClassName="learningTemplateGameViewport"
      >
        {children}
      </LearningLessonShellContent>
    </LearningLessonShell>
  )
}

export function LearningTemplateGameResult({
  actions,
  children,
  description,
  metrics,
  title,
}: LearningTemplateGameResultProps) {
  return (
    <LearningLessonShellContent
      className="learningTemplateGameResultContent"
      pageWrapClassName="learningTemplateGameResultPageWrap"
      viewportClassName="learningTemplateGameResultViewport"
    >
      <section className="learningTemplateGameResultSurface">
        <header className="learningTemplateGameResultHeader">
          <div>
            <h2 className="learningTemplateGameResultTitle">{title}</h2>
            {description ? (
              <p className="learningTemplateGameResultDescription">{description}</p>
            ) : null}
          </div>
          {actions ? <div className="learningTemplateGameResultActions">{actions}</div> : null}
        </header>
        <div className="learningTemplateGameResultGrid">
          {metrics.map((metric, index) => (
            <div className="learningTemplateGameResultMetric" key={index}>
              <p className="learningTemplateGameResultLabel">{metric.label}</p>
              <p className="learningTemplateGameResultValue">{metric.value}</p>
            </div>
          ))}
        </div>
        {children}
      </section>
    </LearningLessonShellContent>
  )
}
